import * as io from 'io-ts';
import { fetchIO, PointIO } from 'sdi/source';

const CLIENT_ID = 'VG9LS1lUaE5oMGRCT0pyRkZkV0xxMDphODRjOTk1Y2Y5YzBmZTVi';

const ImagePropertiesIO = io.interface({
    ca: io.number,
    camera_make: io.string,
    camera_model: io.string,
    captured_at: io.string,
    key: io.string,
    pano: io.boolean,
    sequence_key: io.string,
    user_key: io.string,
    username: io.string,
});

const MapillaryImagesIO = io.interface({
    properties: ImagePropertiesIO,
    geometry: PointIO,
});
export type MapillaryImage = io.TypeOf<typeof MapillaryImagesIO>;

const MapillaryImageGroup = io.interface({
    type: io.literal('FeatureCollection'),
    features: io.array(MapillaryImagesIO),
});
export type MapillaryImageGroup = io.TypeOf<typeof MapillaryImageGroup>;

const fetchMapillaryOptions = () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return { headers: headers };
};

export const fetchMapillaryImages = (lon: number, lat: number) =>
    fetchIO(
        MapillaryImageGroup,
        `https://a.mapillary.com/v3/images?closeto=${lon},${lat}&client_id=${CLIENT_ID}`,
        fetchMapillaryOptions()
    );

// to get the image: https://images.mapillary.com/${key}/thumb-640.jpg
